// extracted by mini-css-extract-plugin
module.exports = {"container":"_2QQQijpKZ2atRs7jIowhR-","header":"_3k7ZuDwvnOYoY7_lg5DXWw","content":"_1xEiJOR2JN_gFAa_4ovJF9","plusHolder":"_2RfT7Rc4S9tQWS9n4BMxKS","plus":"_1yrR49g-QWjvm-uVSnws6i"};